import React from 'react'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import '../../style/assignments.scss'

const AssignmentLeftNav = ({ match, location, assignmentDetails, serverProperties }) =>
  <nav className='assignment-left-nav'>
    <ul className='usa-sidenav-list'>
      <li>
        <NavLink
          activeClassName={location.pathname === match.url ? getLinkStyling(assignmentDetails, serverProperties) : ''}
          to={`${match.url}`}>
          Assignment Summary
      </NavLink>
      </li>
      {isAppraisalQualifiedForAappQuestions(assignmentDetails, serverProperties) &&
        <li>
          <NavLink
            activeClassName='usa-current'
            to={`${match.url}/appraisalAssistance`}>
            AAPP Questions
      </NavLink>
        </li>
      }
      {(assignmentDetails.appraisalCode === 'LAPP' || assignmentDetails.appraisalCode === 'IND' ||
          assignmentDetails.appraisalCode === 'SAPP' || assignmentDetails.appraisalCode === 'LGI' ||
          assignmentDetails.appraisalCode === 'LPL') &&
      <li>
        <NavLink activeClassName={getLinkStyling(assignmentDetails, serverProperties)} to={`${match.url}/documents`}>
          1805
        </NavLink>
      </li>
      }
      <li>
        <NavLink activeClassName='usa-current' to={`${match.url}/correspondence`}>
          Correspondence History
      </NavLink>
      </li>
      <li>
        <NavLink activeClassName='usa-current' to={`${match.url}/details`}>
          Assignment Details
      </NavLink>
      </li>
      <li>
        <NavLink activeClassName='usa-current' to={`${match.url}/notes`}>
          Notes
      </NavLink>
      </li>
    </ul>
  </nav>

function isAppraisalQualifiedForAappQuestions(assignmentDetails, serverProperties) {
  if (assignmentDetails === null || serverProperties === null || (assignmentDetails.salePrice === null && assignmentDetails.refinanceAmount === null)) {
    return false
  }
  //Only redirect for appraisals that have an out for appraisal date after 1/1/20
  const bwnDate = new Date("2020/01/01");
  let isAppraisalAfterBwn = true;
  if (assignmentDetails.latestOutForAppraisalDate < bwnDate.getTime()) {
    isAppraisalAfterBwn = false;
  }

  const qualificationPrice = assignmentDetails.salePrice > assignmentDetails.refinanceAmount ? assignmentDetails.salePrice : assignmentDetails.refinanceAmount
  if ((assignmentDetails.appraisalCode === 'LAPP' || assignmentDetails.appraisalCode === 'IND')
    && qualificationPrice < serverProperties.bwnsalerefinanceprice
    && assignmentDetails.traineeAllowed
    && isAppraisalAfterBwn) {
    return true
  } else {
    return false;
  }
}


function areAappQuestionsEmptyAndRequired(assignmentDetails, serverProperties) {
  return isAppraisalQualifiedForAappQuestions(assignmentDetails, serverProperties) && assignmentDetails.aappUsed === null
}

function getLinkStyling(assignmentDetails, serverProperties) {
  if (areAappQuestionsEmptyAndRequired(assignmentDetails, serverProperties)) {
    return 'disabled-nav-link'
  } else {
    return 'usa-current'
  }
}

const mapStateToProps = (state, ownProps) => ({
  assignmentDetails: state.appraiser && state.appraiser.assignments && state.appraiser.assignments.assignmentDetails ? state.appraiser.assignments.assignmentDetails : {},
  serverProperties: state.serverProperties ? state.serverProperties : {}
})



export default connect(mapStateToProps)(AssignmentLeftNav)
